export default "__VITE_ASSET__CmI0pxQ7__"